<style lang="scss"></style>
<style lang="scss" scoped="scoped">
.biankuang {
  border: 4px solid rgba(108, 167, 255, 1);
  border-radius: 5px;
  box-shadow: 0px 0px 30px 0px rgba(45, 53, 255, 1) inset;
  box-shadow: 0px 0px 80px 0px rgba(45, 53, 255, 1) inset;
}

.yongxinSmallTitle {
  background-image: url(../../../../../../../assets/img/web/yongxin/small_title_bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.yongxinBigTitle {
  background-image: url(../../../../../../../assets/img/web/yongxin/super_big_title_bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;display: flex;flex-direction: column;padding: 10px 20px 20px 20px;">
    <div style="display: flex;justify-content: space-between;flex: 1;">
      <div class="biankuang" style="height: 100%;width: 100%;display:flex;flex-direction: column;">
        <div ref="title" class="yongxinSmallTitle" style="width: 100%;height: 40px;color:white;display:flex;justify-content:center;align-items:center;font-size:20px">
          近7日次品原因Worst5
        </div>
        <div style="width: 100%;display: flex;justify-content: space-between" :style="{ height: chartHeight + 'px' }">
          <div id="yongxinZhijianChart1" style="flex:1" :style="{ height: chartHeight + 'px' }"></div>
        </div>
      </div>
      <div class="biankuang" style="height: 100%;width: 100%;display:flex;flex-direction: column;margin-left: 20px;">
        <div class="yongxinSmallTitle" style="width: 100%;height: 40px;color:white;display:flex;justify-content:center;align-items:center;font-size:20px">
          近7日次品产品Worst5
        </div>
        <div style="width: 100%;display: flex;justify-content: space-between" :style="{ height: chartHeight + 'px' }">
          <div id="yongxinZhijianChart2" style="flex:1" :style="{ height: chartHeight + 'px' }"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_machine_model_machine_count',
  components: {},

  data() {
    return {
      timer: null,
      list1: [],
      list2: [],
      chart1: null,
      option1: null,
      chart2: null,
      option2: null,
      chartHeight: 0
    };
  },
  created() {
    this.timer = setInterval(() => {
      this.listData();
    }, 120000);
    this.listData();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
    this.makeChart();
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    async listData() {
      let response = await this.http.get('/custom/yongxin/quality/board/listWoReportRecordBadGroupByDefect');
      this.list1 = response.data;

      let response2 = await this.http.get('/custom/yongxin/quality/board/listWoReportRecordBadGroupByMaterial');
      this.list2 = response2.data;

      this.makeChart();
    },
    makeChart() {
      let xData = this.list1.map(item => {
        return item.name;
      });
      let yData = this.list1.map(item => {
        return item.badQuantity;
      });
      this.chartHeight = this.$refs.container.offsetHeight - this.$refs.title.offsetHeight - 30;
      if (!this.chart1) {
        this.initChart1();
      }
      this.option1.xAxis.data = xData;
      this.option1.series[0].data = yData;
      this.chart1.setOption(this.option1);

      let xData2 = this.list2.map(item => {
        return item.name;
      });
      let yData2 = this.list2.map(item => {
        return item.badQuantity;
      });
      if (!this.chart12) {
        this.initChart2();
      }
      this.option2.xAxis.data = xData2;
      this.option2.series[0].data = yData2;
      this.chart2.setOption(this.option2);
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.title) {
          return;
        }
        this.chartHeight = this.$refs.container.offsetHeight - this.$refs.title.offsetHeight - 30;
        if (!this.chart1) {
          return;
        }
        if (!this.chart2) {
          return;
        }

        this.chart1.getDom().style.height = this.chartHeight + 'px';
        this.chart1.resize();
        this.chart2.getDom().style.height = this.chartHeight + 'px';
        this.chart2.resize();
      }, 800);
    },
    initChart1() {
      this.option1 = {
        backgroundColor: null,
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            label: {
              formatter: '{value} '
            },
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          },
          backgroundColor: 'rgba(0,0,0,0.8)',
          borderWidth: 0,
          textStyle: {
            color: '#C0C4CC'
          },
          valueFormatter: value => {
            return value; //value.toFixed(2) + 'kwh';
          }
        },
        grid: {
          left: '20',
          right: '20',
          bottom: '10',
          top: '16',
          containLabel: true
        },

        dataZoom: [
          {
            show: false,
            height: 8,
            xAxisIndex: [0],
            bottom: 0,
            start: 0,
            end: 100,
            handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
            handleSize: '100%',
            handleStyle: {
              color: 'rgba(255, 255, 255,1'
            },
            textStyle: {
              color: 'transparent',
              fontSize: 12
            },
            fillerColor: '#CBCED4',
            borderColor: 'transparent',
            backgroundColor: 'transparent',
            showDataShadow: false,
            brushSelect: false
          },
          {
            type: 'inside',
            disabled: false
          }
        ],
        xAxis: {
          show: true,
          type: 'category',
          name: '',
          nameLocation: 'end',
          nameTextStyle: {
            fontSize: 12
          },
          inverse: false,
          splitLine: {
            show: false,
            lineStyle: {
              type: 'dashed',
              color: '#000',
              width: 1
            }
          },
          axisTick: {
            show: false,
            alignWithLabel: false,
            interval: 'auto',
            inside: false,
            length: 5,
            lineStyle: {
              type: 'solid',
              width: 1,
              color: '#909399'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              width: 1,
              color: '#909399'
            }
          },
          axisLabel: {
            margin: 8,
            interval: 'auto',
            rotate: 0,
            fontSize: 12,
            color: 'white'
            // formatter: month => {
            //   return month.substring(4, 6) + this.$t('yue');
            // }
          },
          data: []
        },
        yAxis: [
          {
            show: true,
            type: 'value',
            name: '',
            min: 0,
            nameTextStyle: {
              color: '#909399'
            },

            axisLine: {
              show: false,
              lineStyle: {
                color: '#909399'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              formatter: '{value} ',
              rotate: 0,
              textStyle: {
                color: 'white'
              }
            },
            splitLine: {
              show: false,
              lineStyle: {
                type: 'dashed',
                color: '#606672'
              }
            }
          }
        ],

        series: [
          {
            name: '', //this.$t('nenghao'),
            type: 'bar',
            barWidth: '24px',
            itemStyle: {
              normal: {
                color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#E5DA6F'
                  },
                  {
                    offset: 1,
                    color: '#FB8835'
                  }
                ]),
                barBorderRadius: 12
              }
            },
            label: {
              show: true,
              rotate: 0,
              color: 'white',
              position: 'top',
              fontSize: 16
            },
            data: []
          }
        ]
      };

      var chartDom = document.getElementById('yongxinZhijianChart1');
      this.chart1 = this.echarts.init(chartDom);
      this.option1 && this.chart1.setOption(this.option1);
    },
    initChart2() {
      this.option2 = {
        backgroundColor: null,
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            label: {
              formatter: '{value} '
            },
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          },
          backgroundColor: 'rgba(0,0,0,0.8)',
          borderWidth: 0,
          textStyle: {
            color: '#C0C4CC'
          },
          valueFormatter: value => {
            return value; // value.toFixed(2) + 'kwh';
          }
        },
        grid: {
          left: '20',
          right: '20',
          bottom: '10',
          top: '16',
          containLabel: true
        },

        dataZoom: [
          {
            show: false,
            height: 8,
            xAxisIndex: [0],
            bottom: 0,
            start: 0,
            end: 100,
            handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
            handleSize: '100%',
            handleStyle: {
              color: 'rgba(255, 255, 255,1'
            },
            textStyle: {
              color: 'transparent',
              fontSize: 12
            },
            fillerColor: '#CBCED4',
            borderColor: 'transparent',
            backgroundColor: 'transparent',
            showDataShadow: false,
            brushSelect: false
          },
          {
            type: 'inside',
            disabled: false
          }
        ],
        xAxis: {
          show: true,
          type: 'category',
          name: '',
          nameLocation: 'end',
          nameTextStyle: {
            fontSize: 12
          },
          inverse: false,
          splitLine: {
            show: false,
            lineStyle: {
              type: 'dashed',
              color: '#000',
              width: 1
            }
          },
          axisTick: {
            show: false,
            alignWithLabel: false,
            interval: 'auto',
            inside: false,
            length: 5,
            lineStyle: {
              type: 'solid',
              width: 1,
              color: '#909399'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              width: 1,
              color: '#909399'
            }
          },
          axisLabel: {
            margin: 8,
            interval: 'auto',
            rotate: 0,
            fontSize: 12,
            color: 'white'
            // formatter: month => {
            //   return month.substring(4, 6) + this.$t('yue');
            // }
          },
          data: []
        },
        yAxis: [
          {
            show: true,
            type: 'value',
            name: '',
            min: 0,
            nameTextStyle: {
              color: '#909399'
            },

            axisLine: {
              show: false,
              lineStyle: {
                color: '#909399'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              formatter: '{value} ',
              rotate: 0,
              textStyle: {
                color: 'white'
              }
            },
            splitLine: {
              show: false,
              lineStyle: {
                type: 'dashed',
                color: '#606672'
              }
            }
          }
        ],

        series: [
          {
            name: '', // this.$t('nenghao'),
            type: 'bar',
            barWidth: '24px',
            itemStyle: {
              normal: {
                color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#E59A6F'
                  },
                  {
                    offset: 1,
                    color: '#FB3535'
                  }
                ]),
                barBorderRadius: 12
              }
            },
            label: {
              show: true,
              rotate: 0,
              color: 'white',
              position: 'top',
              fontSize: 16
            },
            data: []
          }
        ]
      };

      var chartDom = document.getElementById('yongxinZhijianChart2');
      this.chart2 = this.echarts.init(chartDom);
      this.option2 && this.chart2.setOption(this.option2);
    }
  }
};
</script>
